import React, { Component } from "react";

import { Button } from "@material-ui/core";

import { Clients } from "./Clients";

import { authenticationService } from '../services';

class MainContainer extends Component {
  state = {
    name: "",
    userInfo: null,
    maxioUserInfo: null,
  };

  componentDidMount() {
    this.handleUpdateName();
    authenticationService.getSfdcUser((userInfo) => {
      console.log(userInfo);
      this.setState({ userInfo: userInfo });
    });
    authenticationService.getMaxioSfdcUser((maxioUserInfo) => {
      console.log(maxioUserInfo);
      this.setState({ maxioUserInfo: maxioUserInfo });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("componentDidUpdate", prevState, prevProps);
    if (prevProps.name !== this.props.name) {
      this.handleUpdateName();
    }
  }

  handleUpdateName = () => {
    this.setState({ name: this.props.name });
  };

  generateSalesforceToken = () => {
    const sfdcClientId = '3MVG9vtcvGoeH2bgCu4iHQNuPOXMqBmjVaSVrtR43etmlin4tC0.tyNDZIZXaNgKLzj7nf3O1OvlKQRgmC9Fs';
    const sfdcApiScope = 'full refresh_token offline_access';
    const redirect_uri = 'https://portal.xencallpay.com/sfdc-callback';

    console.log('generateSalesforceToken')

    var url = 'https://login.salesforce.com/services/oauth2/authorize?client_id=' + sfdcClientId +
      '&redirect_uri=' + redirect_uri +
      '&scope=' + sfdcApiScope +
      '&access_type=offline&display=popup&response_type=code&state=Stripe';

    console.log('generateSalesforceToken - url', url)

    window.location = url;
  };

  generateMaxioSalesforceToken = () => {
    const sfdcClientId = '3MVG9vtcvGoeH2bgCu4iHQNuPOXMqBmjVaSVrtR43etmlin4tC0.tyNDZIZXaNgKLzj7nf3O1OvlKQRgmC9Fs';
    const sfdcApiScope = 'full refresh_token offline_access';
    //const redirect_uri = 'https://portal.xencallpay.com/sfdc-callback';
    const redirect_uri = 'https://bc880ca5a1ba.ngrok.app/sfdc-callback';

    console.log('generateMaxioSalesforceToken')

    var url = 'https://login.salesforce.com/services/oauth2/authorize?client_id=' + sfdcClientId +
      '&redirect_uri=' + redirect_uri +
      '&scope=' + sfdcApiScope +
      '&access_type=offline&display=popup&response_type=code&state=Maxio';

    console.log('generateMaxioSalesforceToken - url', url)

    window.location = url;
  };

  render() {
    const { section, name } = this.props;
    const { userInfo, maxioUserInfo } = this.state;
    console.log(this.state);
    switch (section) {
      case "Home":
        return (<div>
          <h1>StripeConnect</h1>
          { userInfo && <div>
            <h2>{userInfo.display_name}</h2>
            <h2>{userInfo.email}</h2>
            <h2>Salesforce token valid </h2>
          </div>}
          { !userInfo && <h2>Salesforce token invalid, please generate a new one </h2>}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={userInfo != null}
            onClick={this.generateSalesforceToken}
          >
            Generate Salesforce Token
            </Button>
          <h1>MaxioConnect</h1>
          { maxioUserInfo && <div>
            <h2>{maxioUserInfo.display_name}</h2>
            <h2>{maxioUserInfo.email}</h2>
            <h2>Salesforce token valid </h2>
          </div>}
          { !maxioUserInfo && <h2>Salesforce token invalid, please generate a new one </h2>}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={maxioUserInfo != null}
            onClick={this.generateMaxioSalesforceToken}
          >
            Generate Salesforce Token
            </Button>
        </div>);
      case "Migrated Clients":
        return <Clients name={name} migrated={true} />;
      case "Clients to Migrate":
        return <Clients name={name} migrated={false} />;
      default:
        return (<div><h1>{section}</h1></div>);
    }
  }
}

export { MainContainer };
